import { DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { func } from "prop-types";
import DialogTitle from "@mui/material/DialogTitle";

import React from "react";

export const HDDialogTitle = ({ children }) => {
  return (
    <DialogTitle>
      <span style={{ fontSize: "20px", fontWeight: "bold" }}>{children}</span>
    </DialogTitle>
  );
};

export const HDDialogContent = ({ children }) => {
  return (
    <DialogContent>
      <DialogContentText>{children}</DialogContentText>
    </DialogContent>
  );
};

export const HDDialogButtons = ({ children }) => {
  return (
    <DialogActions
      style={{
        justifyContent: "space-between",
        paddingLeft: "24px",
        paddingRight: "24px",
      }}
    >
      {children}
    </DialogActions>
  );
};
